import React, {ErrorInfo} from 'react';

type ErrorBoundaryProps = {};
type ErrorBoundaryState = {
    hasError: boolean;
    error: Error | undefined;
    errorInfo: ErrorInfo | undefined;
};

export class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundary) {
        super(props);
        this.state = {
            hasError: false,
            error: undefined,
            errorInfo: undefined
        };
    }

    static getDerivedStateFromError(error: Error) {
        return {
            hasError: true,
            error
        };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo) {
        console.log('Error Message', error.message);
        console.log('Error Name', error.name);
        console.log('Error Stack', error.stack);

        console.log('Error Info Stack', errorInfo.componentStack);
        console.log(error, errorInfo);

        this.setState({
            error,
            errorInfo
        });
    }

    render() {
        if (this.state.hasError) {
            const emailBody = 'HelpDesk%2C%0A%0AI%20encountered%20the%20following%20error%20while%20using%20the%20Fletch%20application%3A%0A' +
                encodeURIComponent(this.state?.error?.name || '') + ' - ' + encodeURIComponent(this.state?.error?.message || '') + '%0A%0A' +
                'Stack%0A' + encodeURIComponent(this.state?.error?.stack || '') + '%0A%0A' +
                'Component Stack%0A' + encodeURIComponent(this.state?.errorInfo?.componentStack || '') + '%0A%0A' +
                'UserAgent %0A' + encodeURIComponent(navigator.userAgent);

            return (
                <div className="d-flex justify-content-center align-items-center" style={{minHeight: '600px'}}>
                    <div className="p-4" style={{border: '1px solid #ccc', width: '75%'}}>
                        <h1 className="text-center" style={{fontSize: '72pt'}}>
                            <i className="fas fa-exclamation-triangle" style={{color: '#ff6d00'}} />
                            <span className="pl-4">Error</span>
                        </h1>
                        <p style={{fontSize: '18pt'}}>We've encountered an error handling your request. Please click your browser's <em>Refresh</em> button and try again.</p>
                        {/* tslint:disable-next-line:max-line-length */}
                        <p style={{fontSize: '16pt'}}>If the problem persists, please contact the <a href={'mailto:webmaster@us.abb.com?subject=Fletch Error&body=' + emailBody}>HelpDesk</a></p>
                        <p><strong>Error Name</strong> {this.state?.error?.name}</p>
                        <p><strong>Error Message</strong> {this.state?.error?.message}</p>
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}